<template>
<!-- 添单提示 -->
<el-dialog
      title="提示"
      :visible.sync="popAddOrderTips"
      :append-to-body="true"
      class="pop-add-tips"
      width="500px">
      <div class="order-title danger">该客户存在等待您关联开单的记录，请确认是否不按关联开单进行添单！</div>
      <el-checkbox-group v-model="hasAddOrderids" class="order-checkbox">
        <el-checkbox :label="item.resourceId" v-for="(item,index) in hasAddOrderidsList"  :key="index">不再提示，订单编号：{{item.orderNo}}
          <sup class="hasSale" v-show="item.afterSale===1">售</sup>
        </el-checkbox>
      </el-checkbox-group>
      <span slot="footer" class="dialog-footer">
        <el-button @click="popAddOrderTips = false">取 消</el-button>
        <el-button type="primary" @click="closeAddOrderTips">确 定</el-button>
      </span>
    </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      popAddOrderTips: false,
      hasAddOrderids: [],
      hasAddOrderidsList: []
    }
  },
  methods: {
    // 是否可以添加订单
    toAddOrder (item) {
      const postData = {
        assignorId: null,
        customerUserId: item.id
      }
      this.axios.post('/order/customerChannelUserInfo/check/tip', postData).then((res) => {
        console.log(res)
        if (res.code === 0) {
          // 如果为零的话，直接添加
          if (!res.data || res.data.options.length === 0) {
            this.$emit('toAddOrderLink')
          } else {
            this.hasAddOrderidsList = res.data.options
            this.hasAddOrderids = []
            this.popAddOrderTips = true
          }
        }
      })
    },
    //  确订关闭弹窗，并设置忽略
    closeAddOrderTips () {
      if (this.hasAddOrderids.length > 0) {
        const postData = [...this.hasAddOrderids]
        this.axios.post('/order/customerChannelUserInfo/ignore/tip', postData).then((res) => {
          console.log(res)
          if (res.code === 0) {
            this.hasAddOrderidsList = res.data.options
            // 设置完关闭，并跳转
            this.popAddOrderTips = false
            this.$emit('toAddOrderLink')
          }
        })
      } else {
        this.popAddOrderTips = false
        this.$emit('toAddOrderLink')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.pop-add-tips{
  .order-title{
    padding: 5px 0 20px 20px;
  }
  .order-checkbox{
    padding: 0 0 0 30px;
    /deep/ .el-checkbox{
      display: block;
      margin-bottom: 10px;
    }
  }
  .hasSale{
    border: 1px solid red; 
    line-height:16px;
    text-align:center;
    display: inline-block;    
    box-sizing: border-box; 
    width:18px;
    height:18px; 
    color: red; 
    border-radius:10px; 
    font-size: 11px;
    font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
}
}
</style>
